// The number the OS paints on the installed app's icon. Guarded rather than assumed: the
// Badging API only exists in installed PWAs on iOS 16.4+ and desktop Chrome/Edge, and is
// absent entirely on Android Chrome and Firefox, where this has to be a silent no-op.
export function applyAppBadge(nav, count) {
    if (!nav || typeof nav.setAppBadge !== "function" || typeof nav.clearAppBadge !== "function") {
        return Promise.resolve(false);
    }

    const unread = Number(count) || 0;

    // A rejection here means the OS refused the badge -- on iOS, notification permission
    // was never granted. Nothing the page can do about it, and it must not surface as an
    // unhandled rejection.
    return Promise.resolve(unread > 0 ? nav.setAppBadge(unread) : nav.clearAppBadge())
        .then(() => true)
        .catch(() => false);
}

export default applyAppBadge;
